var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChapterCircleThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 519,
    viewBox: "0 0 467 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "inner-line-circle-three",
    d: "M466.21 259.484C466.21 358.43 404.457 442.922 317.407 476.537C291.419 486.596 263.14 492.105 233.605 492.105C204.07 492.105 175.76 486.596 149.772 476.521C62.7371 442.891 1.01562 358.414 1.01562 259.484C1.01562 160.554 62.7371 76.1084 149.772 42.4935C175.76 32.4185 204.039 26.9102 233.605 26.9102C263.171 26.9102 291.419 32.4185 317.407 42.4778C404.457 76.0927 466.21 160.585 466.21 259.5V259.484Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "triangle",
    d: "M207.729 492.109L233.607 518.003L259.5 492.109",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "triangle",
    d: "M207.729 26.8938L233.607 1L259.5 26.8938",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-line-circle-three",
    d: "M452.745 337.634C461.486 313.215 466.226 286.913 466.226 259.497C466.226 232.081 461.486 205.764 452.745 181.345H411.566C381.498 112.922 313.138 65.1836 233.605 65.1836C154.072 65.1836 85.7278 112.922 55.6438 181.345H14.4491C5.73936 205.764 1 232.065 1 259.497C1 286.929 5.73936 313.199 14.4491 337.634H55.6281C85.7121 406.056 154.072 453.811 233.589 453.811C313.107 453.811 381.482 406.056 411.551 337.634H452.73H452.745Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-line-circle-three",
    d: "M442.027 259.515C442.027 344.808 390.805 418.127 317.407 450.408V476.537C291.419 486.596 263.14 492.105 233.605 492.105C204.071 492.105 175.76 486.596 149.772 476.521V450.408C76.3907 418.127 25.168 344.808 25.168 259.515C25.168 174.223 76.3907 100.872 149.772 68.6228V42.4935C175.76 32.4185 204.039 26.9102 233.605 26.9102C263.172 26.9102 291.419 32.4185 317.407 42.4778V68.6385C390.805 100.888 442.027 174.223 442.027 259.531V259.515Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M165.072 481.84V441.367",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M165.072 77.6133V37.1719",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M302.154 481.809V441.367",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M302.154 77.6133V37.1719",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M431.891 323.578H456.466",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M431.891 195.395H456.466",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M35.3373 323.578H10.7617",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M35.3373 195.395H10.7617",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterCircleThree);
export default __webpack_public_path__ + "static/media/chapter-circle-three.d55640cce23bfa3f396b735573d6f6a2.svg";
export { ForwardRef as ReactComponent };